import { Component, OnInit } from '@angular/core';
import { MainService } from '../mainservices.model';
import { ActivatedRoute, Router } from '@angular/router';
import { MainserviceService } from '../mainservice.service';
import { Globle } from 'src/assets/globle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';

declare var $: any;

@Component({
  selector: 'app-mainserviceform',
  templateUrl: './mainserviceform.component.html',
  styleUrls: ['./mainserviceform.component.css']
})

export class MainserviceformComponent implements OnInit {

  mainService: MainService = {} as MainService;
  updateMode = false;
  imagPath: any;
  files: any[] = [];
  active = true;
  spinnerOverlay = false;
  lang: any;

  constructor(private router: Router,
    private service: MainserviceService,
    private globle: Globle,
    private snackBar: MatSnackBar,
    private activateRoute: ActivatedRoute,
    private translate: TranslateService,
    private localStorage: LocalStorageService) { }

  ngOnInit(): void {
    this.imagPath = this.globle.imgPath;
    this.lang = this.localStorage.retrieve("lang");

    this.getUrlParam();
  }

  ngAfterViewInit(): void {
    this.loaddropify();
  }

  loaddropify() {
    var drEvent = $('.dropify').dropify();

    drEvent.on('dropify.afterClear', () => {
      this.mainService.imgUrl = null;
      this.files = [];
    });

  }

  getUrlParam() {
    this.activateRoute.paramMap.subscribe(param => {
      if (param.get("id") != null) {
        this.mainService.id = +param.get("id")!;
        this.updateMode = true;
        this.getById();
      }
    })
  }

  getById() {
    this.spinnerOverlay = true;
    this.service.getById(this.mainService.id).subscribe(data => {
      this.mainService = data
      this.spinnerOverlay = false;
      // this.mainService.status == 1 ? this.active = true : this.active = false;
      this.fillDropifyImage(this.imagPath + this.mainService.imgUrl);

    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
    })
  }

  back() {
    this.router.navigate(["./master/services/mainservicelist"]);
  }

  submit() {
    this.spinnerOverlay = true;
    // this.active ? this.mainService.status = 1 : this.mainService.status = 0;
    if (this.files.length > 0) {
      this.uploadImage();
    }
    else {
      !this.updateMode ? this.create() : this.update();
    }
  }

  create() {

    this.service.Create(this.mainService).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("createdSuccessfully"), 'snackBarSuccess');
      this.back();
    },
      error => {
        console.log(error);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }

        this.spinnerOverlay = false;
      })
  }

  update() {

    this.service.Update(this.mainService).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.back();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }

      })
  }

  onSelectImage(files: any) {
    this.files = files.target.files;
  }

  uploadImage() {

    let fileToUpload = <File>this.files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    this.service.upload(formData).subscribe(data => {
      this.mainService.imgUrl = data["dbPath"];
      !this.updateMode ? this.create() : this.update();
    }, error => {
      console.log(error);
      this.openSnackBar(error.error.message, 'snackBarError');
      this.spinnerOverlay = false;
    });
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass

    });
  }

  fillDropifyImage(imgUrl: any) {
    var drEvent = $('.dropify').dropify(
      {
        defaultFile: imgUrl
      });
    drEvent = drEvent.data('dropify');
    drEvent.resetPreview();
    //drEvent.clearElement();
    drEvent.settings.defaultFile = imgUrl;
    drEvent.destroy();
    drEvent.init();
  }

}
